import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserActiveGuard } from 'src/app/core/guards/user-active.guard';
import { RoleGuard } from 'src/app/core/guards/role.guard';
import { CompanyAccessGuard } from 'src/app/core/guards/company-access.guard';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BILLING, COMERCIAL_TURN, DISPATCH_CARGO_LOOKER, FREQUENT_ROUTES_LOOKER, FULFILLMENTS, FULFILLMENTS_CLIENTS, HISTORICAL_DOCUMENTS, HISTORICAL_KPI, LOST_SALES, OPERATION_ITR, OPERATIONS_ROUTES_LOOKER, OPERATIONS_TURN, PAYMENTS_DASHBOARD, PROFITABILITY_ANALYSIS, REPORT_UIAF, SICETAC, STOPED_CARGO_LOOKER, VEHICLE_ANALYTICS_LOOKER, VEHICLES_OWN_FLEET } from './dashboards';

const routes: Routes = [
  {
    path: '',
    data: { breadcrumb: 'Analítica de datos' },
    children: [
      {
        path: 'analyticsOperations',
        canActivate: [UserActiveGuard, RoleGuard],
        children: [
          // DONT CHANGE. BY THIS WAY CompanyAccessGuard WILL AWAIT THE PREVIOUS GUARDS
          // IF YOU DO NOT, IT MAY CAUSE LOST SESSION ON RELOADING PAGE
          {
            path: '',
            canActivate: [CompanyAccessGuard],
            component: DashboardComponent,
            data: {
              breadcrumb: 'Operaciones',
              dashboard: OPERATIONS_ROUTES_LOOKER,
              params: {
                'ds1.p1': { hashed: true, valueToken: 'USER_COMPANY' },
                'ds1.p2': { hashed: true, valueToken: 'HOLDER_COMPANY' },
                'ds2.p1': { hashed: true, valueToken: 'USER_COMPANY' },
                'ds2.p2': { hashed: true, valueToken: 'HOLDER_COMPANY' },
                'ds3.p1': { hashed: true, valueToken: 'USER_COMPANY' },
                'ds3.p2': { hashed: true, valueToken: 'HOLDER_COMPANY' },
                'ds4.p1': { hashed: true, valueToken: 'USER_COMPANY' },
                'ds4.p2': { hashed: true, valueToken: 'HOLDER_COMPANY' },
              },
              enableSelectorToRoot: true
            }
          }
        ]
      },
      {
        path: 'vehicleAnalytics',
        canActivate: [UserActiveGuard, RoleGuard],
        children: [
          // DONT CHANGE. BY THIS WAY CompanyAccessGuard WILL AWAIT THE PREVIOUS GUARDS
          // IF YOU DO NOT, IT MAY CAUSE LOST SESSION ON RELOADING PAGE
          {
            path: '',
            canActivate: [CompanyAccessGuard],
            component: DashboardComponent,
            data: {
              breadcrumb: 'Vehículos',
              dashboard: VEHICLE_ANALYTICS_LOOKER,
              params: {
                'ds1.p1': { hashed: true, valueToken: 'USER_COMPANY' },
                'ds2.p1': { hashed: true, valueToken: 'HOLDER_COMPANY' },
              }
            }
          }
        ]
      },
      {
        path: 'frequentRoutes',
        canActivate: [UserActiveGuard, RoleGuard],
        children: [
          // DONT CHANGE. BY THIS WAY CompanyAccessGuard WILL AWAIT THE PREVIOUS GUARDS
          // IF YOU DO NOT, IT MAY CAUSE LOST SESSION ON RELOADING PAGE
          {
            path: '',
            canActivate: [CompanyAccessGuard],
            component: DashboardComponent,
            data: {
              breadcrumb: 'Rutas frecuentes',
              dashboard: FREQUENT_ROUTES_LOOKER,
              params: {
                'ds1.p1': { hashed: true, valueToken: 'HOLDER_COMPANY' },
                'ds1.p2': { hashed: true, valueToken: 'USER_COMPANY', defaultToken: 'HOLDER_COMPANY' },
              },
              enableSelectorToRoot: true
            }
          }
        ]
      },
      {
        path: 'dispatch',
        canActivate: [UserActiveGuard, RoleGuard],
        children: [
          // DONT CHANGE. BY THIS WAY CompanyAccessGuard WILL AWAIT THE PREVIOUS GUARDS
          // IF YOU DO NOT, IT MAY CAUSE LOST SESSION ON RELOADING PAGE
          {
            path: '',
            canActivate: [CompanyAccessGuard],
            component: DashboardComponent,
            data: {
              breadcrumb: 'Despachos',
              dashboard: DISPATCH_CARGO_LOOKER,
              params: {
                'ds0.p1': { hashed: true, valueToken: 'HOLDER_COMPANY' },
              }
            }
          }
        ]
      },
      {
        path: 'stopedCargos',
        canActivate: [UserActiveGuard, RoleGuard],
        children: [
          // DONT CHANGE. BY THIS WAY CompanyAccessGuard WILL AWAIT THE PREVIOUS GUARDS
          // IF YOU DO NOT, IT MAY CAUSE LOST SESSION ON RELOADING PAGE
          {
            path: '',
            canActivate: [CompanyAccessGuard],
            component: DashboardComponent,
            data: {
              breadcrumb: 'Servicios detenidos',
              dashboard: STOPED_CARGO_LOOKER,
              params: {
                'ds0.p1': { hashed: true, valueToken: 'HOLDER_COMPANY' },
                'ds0.p2': { hashed: true, valueToken: 'USER_COMPANY', defaultToken: 'HOLDER_COMPANY' },
              },
              enableSelectorToRoot: true
            },
          }
        ]
      },
      {
        path: 'historicalKPI',
        canActivate: [UserActiveGuard, RoleGuard],
        children: [
          // DONT CHANGE. BY THIS WAY CompanyAccessGuard WILL AWAIT THE PREVIOUS GUARDS
          // IF YOU DO NOT, IT MAY CAUSE LOST SESSION ON RELOADING PAGE
          {
            path: '',
            canActivate: [CompanyAccessGuard],
            component: DashboardComponent,
            data: {
              breadcrumb: 'Métricas históricas',
              dashboard: HISTORICAL_KPI,
              params: {
                'ds0.p1': { hashed: true, valueToken: 'HOLDER_COMPANY' },
                'ds0.p2': { hashed: true, valueToken: 'USER_COMPANY', defaultToken: 'HOLDER_COMPANY' },
              },
              enableSelectorToRoot: true
            },
          }
        ]
      },
      {
        path: 'paymentsDashboard',
        canActivate: [UserActiveGuard, RoleGuard],
        children: [
          // DONT CHANGE. BY THIS WAY CompanyAccessGuard WILL AWAIT THE PREVIOUS GUARDS
          // IF YOU DO NOT, IT MAY CAUSE LOST SESSION ON RELOADING PAGE
          {
            path: '',
            component: DashboardComponent,
            data: {
              breadcrumb: 'Pagos',
              dashboard: PAYMENTS_DASHBOARD,
              params: {
                'ds0.p1': { hashed: true, valueToken: 'HOLDER_COMPANY' }
              }
            },
          }
        ]
      },
      {
        path: 'analyticsBilling',
        canActivate: [UserActiveGuard, RoleGuard],
        children: [
          // DONT CHANGE. BY THIS WAY CompanyAccessGuard WILL AWAIT THE PREVIOUS GUARDS
          // IF YOU DO NOT, IT MAY CAUSE LOST SESSION ON RELOADING PAGE
          {
            path: '',
            canActivate: [CompanyAccessGuard],
            component: DashboardComponent,
            data: {
              breadcrumb: 'Facturación',
              dashboard: BILLING,
              params: {
                'ds0.p1': { hashed: true, valueToken: 'HOLDER_COMPANY' },
              },
            },
          }
        ]
      },
      {
        path: 'operationITR',
        canActivate: [UserActiveGuard, RoleGuard],
        children: [
          // DONT CHANGE. BY THIS WAY CompanyAccessGuard WILL AWAIT THE PREVIOUS GUARDS
          // IF YOU DO NOT, IT MAY CAUSE LOST SESSION ON RELOADING PAGE
          {
            path: '',
            canActivate: [CompanyAccessGuard],
            component: DashboardComponent,
            data: {
              breadcrumb: 'Operación ITR',
              dashboard: OPERATION_ITR,
              params: {
                'ds1.p1': { hashed: true, valueToken: 'HOLDER_COMPANY' },
              },
            },
          }
        ]
      },
      {
        path: 'operationsTurn',
        canActivate: [UserActiveGuard, RoleGuard],
        children: [
          // DONT CHANGE. BY THIS WAY CompanyAccessGuard WILL AWAIT THE PREVIOUS GUARDS
          // IF YOU DO NOT, IT MAY CAUSE LOST SESSION ON RELOADING PAGE
          {
            path: '',
            canActivate: [CompanyAccessGuard],
            component: DashboardComponent,
            data: {
              breadcrumb: 'Operaciones Enturnamiento',
              dashboard: OPERATIONS_TURN,
              params: {
                'ds0.p1': { hashed: true, valueToken: 'HOLDER_COMPANY' },
              },
            },
          }
        ]
      },
      {
        path: 'comercialTurn',
        canActivate: [UserActiveGuard, RoleGuard],
        children: [
          // DONT CHANGE. BY THIS WAY CompanyAccessGuard WILL AWAIT THE PREVIOUS GUARDS
          // IF YOU DO NOT, IT MAY CAUSE LOST SESSION ON RELOADING PAGE
          {
            path: '',
            canActivate: [CompanyAccessGuard],
            component: DashboardComponent,
            data: {
              breadcrumb: 'Comercial Enturnamiento',
              dashboard: COMERCIAL_TURN,
              params: {
                'ds0.p1': { hashed: true, valueToken: 'HOLDER_COMPANY' },
              },
            },
          }
        ]
      },
      {
        path: 'sicetac',
        canActivate: [UserActiveGuard, RoleGuard],
        children: [
          // DONT CHANGE. BY THIS WAY CompanyAccessGuard WILL AWAIT THE PREVIOUS GUARDS
          // IF YOU DO NOT, IT MAY CAUSE LOST SESSION ON RELOADING PAGE
          {
            path: '',
            component: DashboardComponent,
            data: {
              breadcrumb: 'Sicetac',
              dashboard: SICETAC,
            },
          }
        ]
      },
      {
        path: 'vehiclesOwnFleet',
        canActivate: [UserActiveGuard, RoleGuard],
        children: [
          // DONT CHANGE. BY THIS WAY CompanyAccessGuard WILL AWAIT THE PREVIOUS GUARDS
          // IF YOU DO NOT, IT MAY CAUSE LOST SESSION ON RELOADING PAGE
          {
            path: '',
            canActivate: [CompanyAccessGuard],
            component: DashboardComponent,
            data: {
              breadcrumb: 'Mis vehículos',
              dashboard: VEHICLES_OWN_FLEET,
              params: {
                'ds0.p1': { hashed: true, valueToken: 'HOLDER_COMPANY' },
              },
            },
          }
        ]
      },
      {
        path: 'reportUIAF',
        canActivate: [UserActiveGuard, RoleGuard],
        children: [
          // DONT CHANGE. BY THIS WAY CompanyAccessGuard WILL AWAIT THE PREVIOUS GUARDS
          // IF YOU DO NOT, IT MAY CAUSE LOST SESSION ON RELOADING PAGE
          {
            path: '',
            canActivate: [CompanyAccessGuard],
            component: DashboardComponent,
            data: {
              breadcrumb: 'Reporte UIAF',
              dashboard: REPORT_UIAF,
              params: {
                'ds0.p1': { hashed: true, valueToken: 'HOLDER_COMPANY' },
              },
            },
          }
        ]
      },
      {
        path: 'fulfillments',
        canActivate: [UserActiveGuard, RoleGuard],
        children: [
          // DONT CHANGE. BY THIS WAY CompanyAccessGuard WILL AWAIT THE PREVIOUS GUARDS
          // IF YOU DO NOT, IT MAY CAUSE LOST SESSION ON RELOADING PAGE
          {
            path: '',
            canActivate: [CompanyAccessGuard],
            component: DashboardComponent,
            data: {
              breadcrumb: 'Cumplidos',
              dashboard: FULFILLMENTS,
              params: {
                'ds0.p1': { hashed: true, valueToken: 'HOLDER_COMPANY' },
              },
            },
          }
        ]
      },
      {
        path: 'fulfillmentsClients',
        canActivate: [UserActiveGuard, RoleGuard],
        children: [
          // DONT CHANGE. BY THIS WAY CompanyAccessGuard WILL AWAIT THE PREVIOUS GUARDS
          // IF YOU DO NOT, IT MAY CAUSE LOST SESSION ON RELOADING PAGE
          {
            path: '',
            canActivate: [CompanyAccessGuard],
            component: DashboardComponent,
            data: {
              breadcrumb: 'Cumplidos clientes',
              dashboard: FULFILLMENTS_CLIENTS,
              params: {
                'ds0.p1': { hashed: true, valueToken: 'HOLDER_COMPANY' },
                'ds0.p2': { hashed: true, valueToken: 'USER_COMPANY', defaultToken: 'HOLDER_COMPANY' },
              },
              enableSelectorToRoot: true
            },
          }
        ]
      },
      {
        path: 'lostSales',
        canActivate: [UserActiveGuard, RoleGuard],
        children: [
          // DONT CHANGE. BY THIS WAY CompanyAccessGuard WILL AWAIT THE PREVIOUS GUARDS
          // IF YOU DO NOT, IT MAY CAUSE LOST SESSION ON RELOADING PAGE
          {
            path: '',
            canActivate: [CompanyAccessGuard],
            component: DashboardComponent,
            data: {
              breadcrumb: 'Venta perdida',
              dashboard: LOST_SALES,
              params: {
                'ds0.p1': { hashed: true, valueToken: 'HOLDER_COMPANY' },
                'ds1.p1': { hashed: true, valueToken: 'HOLDER_COMPANY' },
              },
            },
          }
        ]
      },
      {
        path: 'historicalDocuments',
        canActivate: [UserActiveGuard, RoleGuard],
        children: [
          // DONT CHANGE. BY THIS WAY CompanyAccessGuard WILL AWAIT THE PREVIOUS GUARDS
          // IF YOU DO NOT, IT MAY CAUSE LOST SESSION ON RELOADING PAGE
          {
            path: '',
            canActivate: [CompanyAccessGuard],
            component: DashboardComponent,
            data: {
              breadcrumb: 'Histórico de documentos',
              dashboard: HISTORICAL_DOCUMENTS,
              params: {
                "ds1.p1": { hashed: true, valueToken: 'HOLDER_COMPANY' },
                "ds2.p1": { hashed: true, valueToken: 'HOLDER_COMPANY' },
                "ds3.p1": { hashed: true, valueToken: 'HOLDER_COMPANY' },
              },
            },
          }
        ]
      },
      {
        path: 'profitabilityAnalysis',
        canActivate: [UserActiveGuard, RoleGuard],
        children: [
          // DONT CHANGE. BY THIS WAY CompanyAccessGuard WILL AWAIT THE PREVIOUS GUARDS
          // IF YOU DO NOT, IT MAY CAUSE LOST SESSION ON RELOADING PAGE
          {
            path: '',
            canActivate: [CompanyAccessGuard],
            component: DashboardComponent,
            data: {
              breadcrumb: 'Análisis de rentabilidad',
              dashboard: PROFITABILITY_ANALYSIS,
              params: {
                'ds0.p1': { hashed: true, valueToken: 'HOLDER_COMPANY' },
              },
            },
          }
        ]
      },
      { path: '**', redirectTo: '/analytics/operations' }
    ]
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class AnalyticsRoutingModule { }
